export enum CustomerDPApiErrorTypes {
  LoadBlendStateError,
}

export class CustomerDPApiError {
  constructor(public type: CustomerDPApiErrorTypes, public error: Error) {}
}
